import type { ContainerProps } from 'reshaped'
import { Container as ReshapedContainer } from 'reshaped/bundle'

/**
 * Common Container properties so things like width can be defined once
 * @param props
 * @constructor
 */
export const Container = (props: ContainerProps) => <ReshapedContainer width="1280px" {...props} />
